import React from "react";
import { Box, Container, Typography, Divider } from "@mui/material";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "examples/Footers/DefaultFooter";
import MKBox from "components/MKBox";

const RefundPolicy = () => {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/search-artists",
          label: "Search Artists",
          color: "info",
        }}
        md
        dark
      />
      <Box sx={{ bgcolor: "#fafafa", py: 6 }}>
        <Container maxWidth="md" sx={{ mt:12}}>
          {/* Page Title */}
          <Typography variant="h3" fontWeight="bold" textAlign="center" mb={3}>
            Refund Policy
          </Typography>

          <Typography
            variant="body2"
            textAlign="center"
            color="text.secondary"
            mb={5}
          >
            Last Updated: 22 November 2025
          </Typography>

          {/* Description */}
          <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
            At MakeMyShows, we strive to ensure a smooth and reliable experience
            for both Clients and Artists. If a booking needs to be changed or
            cancelled, the process outlined below must be followed to ensure
            eligibility for refunds and correct processing.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Refund Conditions */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            Cancellation & Refund Process
          </Typography>

          <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
            Clients must notify MakeMyShows of any cancellation, changes, or
            withdrawal from a booking through an official communication channel
            such as:
            <br />
            <br />
            • Email: support@makemyshows.in
            <br />
            • WhatsApp (Official Business Account)
            <br />
            • Phone Call to the MakeMyShows Support Team
            <br />
            <br />
            Informing the Artist directly **is not considered a valid
            cancellation**. All booking-related communication must be routed
            through MakeMyShows to be legally recognized.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Refund Timeline */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            Refund Timeframe
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
            Once a cancellation has been approved based on our cancellation
            policy, refunds (if applicable) will be processed within:
            <br />
            <br />
            <strong>✔ 7 Business Days</strong>
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Policy Rules */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            Policy Authority
          </Typography>

          <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
            In case an Artist uses their own contract separate from the standard
            contract provided by MakeMyShows, the following applies:
            <br />
            <br />
            <strong>
              The MakeMyShows Terms & Conditions and Cancellation Policy shall
              override any conflicting terms and remain legally binding.
            </strong>
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Closing */}
          <Typography variant="body1" sx={{ lineHeight: 1.8 }} mb={3}>
            By booking through MakeMyShows, users agree to abide by this Refund
            Policy as part of our platform terms.
          </Typography>

          <Typography
            variant="body1"
            textAlign="center"
            mt={5}
            sx={{ fontStyle: "italic" }}
          >
            Thank you for choosing MakeMyShows.
          </Typography>
        </Container>
      </Box>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
};

export default RefundPolicy;
